import { createSlice } from "@reduxjs/toolkit";
import { fetchQuotationAnalytics, fetchQuotationList } from "./thunk";

interface QuotationSummaryState {
  // Analytics data
  analytics: {
    total_quotations: number;
    from_enquiry: number;
    direct: number;
    won: number;
    lost: number;
    pending: number;
    from_enquiry_won: number;
    from_enquiry_lost: number;
    from_enquiry_pending: number;
    direct_won: number;
    direct_lost: number;
    direct_pending: number;
  } | null;
  analyticsLoading: boolean;
  analyticsError: string | null;

  // List data
  quotationList: any[];
  totalRecords: number;
  listLoading: boolean;
  listError: string | null;
}

const initialState: QuotationSummaryState = {
  analytics: null,
  analyticsLoading: false,
  analyticsError: null,
  quotationList: [],
  totalRecords: 0,
  listLoading: false,
  listError: null,
};

const quotationSummarySlice = createSlice({
  name: "quotationSummary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Analytics thunks
      .addCase(fetchQuotationAnalytics.pending, (state) => {
        state.analyticsLoading = true;
        state.analyticsError = null;
      })
      .addCase(fetchQuotationAnalytics.fulfilled, (state, action) => {
        state.analyticsLoading = false;
        state.analytics = action.payload;
      })
      .addCase(fetchQuotationAnalytics.rejected, (state, action) => {
        state.analyticsLoading = false;
        state.analyticsError =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch quotation analytics";
        // Set default values on error
        state.analytics = {
          total_quotations: 0,
          from_enquiry: 0,
          direct: 0,
          won: 0,
          lost: 0,
          pending: 0,
          from_enquiry_won: 0,
          from_enquiry_lost: 0,
          from_enquiry_pending: 0,
          direct_won: 0,
          direct_lost: 0,
          direct_pending: 0,
        };
      })
      // List thunks
      .addCase(fetchQuotationList.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchQuotationList.fulfilled, (state, action) => {
        state.listLoading = false;
        state.quotationList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchQuotationList.rejected, (state, action) => {
        state.listLoading = false;
        state.listError =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch quotation list";
        state.quotationList = [];
        state.totalRecords = 0;
      });
  },
});

export default quotationSummarySlice.reducer;

